import React from 'react'

interface WebsiteStylesSettingsListItemProps {
  label: string
  onClick?: () => void
  icon?: React.ReactNode
}

export const WebsiteStylesSettingsListItem = ({
  label,
  onClick,
  icon,
}: WebsiteStylesSettingsListItemProps) => {
  return (
    <button
      className="flex min-h-15 cursor-pointer items-center justify-start gap-1.5 rounded-md px-4 py-1.5 transition-[all_0.3s_cubic-bezier(0,0,0.8,1)] hover:bg-bgSecondary"
      onClick={onClick}
    >
      {icon}
      <span className="text-M">{label}</span>
    </button>
  )
}
